export class FiltrosOperacion{
   
   Id : string ='';
   IdOperacion: string = '';
   Estado : string ='P';
   IdAd : string ='';
   CodOperacion : string ='';
   


}
